import upload from './upload.ts'
import download from './download.ts'

export default {

    namespaced: true,
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        upload,
        download,
    }

}